import { FC, useEffect, useState } from 'react';
import { formatDate } from '@/hooks/useDate';

interface LastUpdateInfoProps {
  fileData: any;
  pageNumber: number;
}

const LastUpdateInfo: FC<LastUpdateInfoProps> = ({ fileData, pageNumber }) => {
  const [lastUpdateDate, setLastUpdateDate] = useState<string>('');
  const [lastUpdateAuthor, setLastUpdateAuthor] = useState<string>('');

  useEffect(() => {
    if (fileData && pageNumber === fileData.page_data.page_number) {
      setLastUpdateDate(formatDate(fileData.page_data.updated_at));
      setLastUpdateAuthor(fileData.page_data.author);
    }
  }, [fileData, pageNumber]);

  if (!lastUpdateDate || !lastUpdateAuthor) return null;

  return (
    <div className={'flex items-center border px-3 py-2 text-sm bg-[#ffedd5] border-[#f6dbb6]'}>
      <span>
        Poslední úprava: <strong>{lastUpdateAuthor}</strong> | <strong>{lastUpdateDate}</strong>
      </span>
    </div>
  );
};

export default LastUpdateInfo;
